import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Dropdown, Menu, Space } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import { DeleteToken } from "../../utils";
import store from "./../../redux/store";
import { UserServices } from "../../redux/Services";
import jwt_decode from "jwt-decode";
const TopBar = ({ collapsed, setCollapsed }) => {
  const navigate = useNavigate();
  const handleLogout = async () => {
    /* navigate("/login", { replace: true }); */
    const respo = await UserServices.logoutUserApi();
    if (respo) {
      store?.dispatch({ type: "LOGOUT" });
      DeleteToken();
      console.log(respo, "Logout response");
      window.location.href = "/login";
    }
  };

  const token = localStorage.getItem("lpl_abha:token");
  const decoded = jwt_decode(token);
  const menu = (
    <div className="profile2">
      <div>
        <Button
          className="profile-btn"
          icon={<UserOutlined />}
          type="text"
        ></Button>
      </div>
      <div>
        <h5><strong>Name:</strong> {decoded.name}</h5>
        <h5><strong>Email:</strong> {decoded.email}</h5>
        <h5><strong>Mobile:</strong> {decoded.mobile}</h5>
      </div>
    </div>
  );

  return (
    <div className="flex justify-content-between align-items-center">
      <div>
        {React.createElement(
          collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
          {
            className: "trigger",
            onClick: () => setCollapsed(!collapsed),
          }
        )}
      </div>
      <div className="mr-20">
        <Dropdown overlay={menu} trigger={["hover"]}>
          <Button className="profile-btn2" type="text">
            <Space align="center">
              <UserOutlined />
              {decoded.name}
            </Space>
          </Button>
        </Dropdown>
        <span className="logout-btn ml-10" onClick={() => handleLogout()}>
          Logout
          <LogoutOutlined />
        </span>
      </div>
    </div>
  );
};

export default TopBar;
